import { useEffect } from "react";

/**
 * Applies per-page SEO metadata (title, description, canonical, OG, Twitter)
 * without touching any visual layout. Cleans up on unmount.
 */
export function useSeo({ title, description, path }) {
  useEffect(() => {
    const canonicalUrl = `https://gambit-immo.fr${path || "/"}`;

    if (title) document.title = title;

    const setMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.tag || "meta");
        Object.entries(attrs.attributes || {}).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      if (attrs.content !== undefined) el.setAttribute("content", attrs.content);
      if (attrs.href !== undefined) el.setAttribute("href", attrs.href);
    };

    if (description) {
      setMeta('meta[name="description"]', {
        attributes: { name: "description" },
        content: description,
      });
      setMeta('meta[property="og:description"]', {
        attributes: { property: "og:description" },
        content: description,
      });
      setMeta('meta[name="twitter:description"]', {
        attributes: { name: "twitter:description" },
        content: description,
      });
    }

    if (title) {
      setMeta('meta[property="og:title"]', {
        attributes: { property: "og:title" },
        content: title,
      });
      setMeta('meta[name="twitter:title"]', {
        attributes: { name: "twitter:title" },
        content: title,
      });
    }

    setMeta('meta[property="og:url"]', {
      attributes: { property: "og:url" },
      content: canonicalUrl,
    });

    setMeta('link[rel="canonical"]', {
      tag: "link",
      attributes: { rel: "canonical" },
      href: canonicalUrl,
    });
  }, [title, description, path]);
}
